import { createContext, useContext } from 'react';

export { Can } from '@casl/react';

export const AbilityContext = createContext<any>(undefined);
export const useAbilityContext = () => useContext(AbilityContext);
